<template>
    <nav class="bg-inherit hidden at1024:block">
        <h2
            v-if="header"
            class="text-base type-secondary font-medium mb-5 whitespace-nowrap"
        >
            {{ header }}
        </h2>
        <ul v-if="clickToScroll">
            <li v-for="(section, i) in sections" :key="i">
                <button
                    v-if="!section.isHidden"
                    :disabled="section.isDisabled"
                    @click.prevent="$emit('scrollTo', section.name)"
                    :class="
                        modelValue === section.name
                            ? 'border-black type-primary font-medium'
                            : 'border-gray-150 type-tertiary'
                    "
                    class="block border-l-2 px-5 py-1.5 text-left text-sm truncate w-full hover:text-gray-800 disabled:opacity-50 disabled:hover:text-gray"
                >
                    {{ $t(section.name) }}
                </button>
            </li>
        </ul>
        <ul v-else class="w-full">
            <li class="w-full" v-if="all">
                <button
                    @click="setFilter(null)"
                    :class="
                        !modelValue
                            ? 'bg-gray-tier-5 border-black dark:border-white type-primary'
                            : 'border-gray-tier-5 type-secondary hover:type-primary'
                    "
                    class="block border-l-2 font-medium px-3 py-2 text-left truncate w-full disabled:opacity-50 disabled:hover:type-tertiary"
                >
                    {{ $t("All") }}
                </button>
            </li>
            <li class="w-full" v-for="(section, i) in sections" :key="i">
                <button
                    @click="
                        modelValue = section.name;
                        setFilter(section.name);
                    "
                    :class="
                        modelValue === section
                            ? 'bg-gray-tier-5 border-blue !type-primary'
                            : 'border-gray-tier-5 type-secondary hover:type-primary'
                    "
                    class="block border-l-2 font-medium px-3 py-2 text-left truncate w-full disabled:opacity-50 disabled:hover:type-tertiary"
                >
                    {{ $t(section.name) }}
                </button>
            </li>
        </ul>
    </nav>
</template>

<script setup>
import { BaseSvg } from "@/Components";
import { useFilterHistory } from "@/Composables";

const { setFilter } = useFilterHistory();
const emits = defineEmits(["scrollTo", "update:modelValue"]);
const props = defineProps([
    "sections",
    "modelValue",
    "clickToScroll",
    "header",
    "all",
]);
</script>
